import React, { memo, useMemo } from "react";
import { useUserState } from "../../../Context/UserContext";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  useMediaQuery,
} from "@mui/material";
import moment from "moment";
import styles from "./FinanceTable.module.css";

const FinanceTable = memo((props) => {
  const { user } = useUserState();
  const mobileView = useMediaQuery("(max-width: 600px)");
  console.log(props.transactionData);
  console.log(props.search);
  // Memoize filtered transactions based on search
  const filteredTransactionData = useMemo(() => {
    const searchTerm = props.search.trim().toLowerCase();
    if (!searchTerm) return props.transactionData;

    return props.transactionData.filter((transaction) => {
      const transactionString = `${transaction.city} ${
        !user.vendorMode ? transaction.vendor_name : transaction.client_name
      } ${transaction.city} ${transaction.street} ${transaction.job_id} ${
        transaction.job_title
      }`.toLowerCase();

      return transactionString.includes(searchTerm);
    });
  }, [props.search, props.transactionData, user.vendorMode]);

  const getTableRows = (transactionData) => {
    return transactionData.map((transaction, index) => (
      <TableRow
        key={`${transaction.invoice_id}_${
          transaction.received_payment_id || index
        }`} // Create a unique key
        hover
        className={styles.onHover}
        onClick={() => props.setOpenTransaction(index)}
      >
        <TableCell style={{ padding: "0.5rem" }}>
          {moment(transaction.date_finished).format("MMM Do YYYY")}
        </TableCell>
        <TableCell style={{ padding: "0.5rem" }}>
          {!user.vendorMode
            ? `${transaction.vendor_name}`
            : `${transaction.client_name}`}
        </TableCell>
        <TableCell style={{ padding: "0.5rem" }}>
          {`${transaction.street} ${transaction.city}`}
        </TableCell>
        <TableCell style={{ padding: "0.5rem" }}>
          {transaction.job_title}
        </TableCell>
        <TableCell style={{ padding: "0.5rem" }}>
          {transaction.job_id}
        </TableCell>
        <TableCell style={{ padding: "0.5rem" }}>
          $
          {user.vendorMode
            ? transaction.total_vendor_charge.toFixed(2)
            : transaction.total_amount.toFixed(2)}
        </TableCell>
        <TableCell style={{ padding: "0.5rem" }}>
          $
          {transaction.received_amount
            ? transaction.received_amount.toFixed(2)
            : 0.0}
        </TableCell>
        <TableCell style={{ padding: "0.5rem" }}>
          {transaction.bank_account ? `****${transaction.bank_account}` : ""}
        </TableCell>
        <TableCell style={{ padding: "0.5rem" }}>
          $
          {(() => {
            // Get all payments for this job
            const jobPayments = transactionData.filter(
              (t) => t.job_id === transaction.job_id
            );

            // Find index of current payment
            const currentIndex = jobPayments.findIndex(
              (p) => p.received_payment_id === transaction.received_payment_id
            );

            // Get the total vendor charge (should be same across payments for this job)
            const total = parseFloat(transaction.total_vendor_charge || 0);

            // Sum only payments up to and including the current one
            const receivedSoFar = jobPayments
              .slice(0, currentIndex + 1)
              .reduce((sum, p) => sum + parseFloat(p.received_amount || 0), 0);

            // Calculate remaining balance
            const remaining = (total - receivedSoFar).toFixed(2);

            return remaining;
          })()}
        </TableCell>
      </TableRow>
    ));
  };

  return (
    <TableContainer component={Paper} style={{ overflowX: "auto" }}>
      <Table className={styles.table} aria-label="Finance Table">
        <TableHead>
          <TableRow>
            <TableCell
              style={{
                width: "5rem",
                textAlign: mobileView ? "center" : "left",
                paddingLeft: !mobileView ? "1rem" : "0",
              }}
            >
              Date
            </TableCell>
            <TableCell
              style={{
                width: "5rem",
                textAlign: mobileView ? "center" : "left",
                paddingLeft: !mobileView ? "1rem" : "0",
              }}
            >
              {!user.vendorMode ? "Vendor" : "Client"}
            </TableCell>
            <TableCell
              style={{
                width: "6rem",
                textAlign: mobileView ? "center" : "left",
                paddingLeft: !mobileView ? "1rem" : "0",
              }}
            >
              Property
            </TableCell>
            <TableCell
              style={{
                width: "15rem",
                textAlign: mobileView ? "center" : "left",
                paddingLeft: !mobileView ? "1rem" : "0",
              }}
            >
              Description
            </TableCell>
            <TableCell
              style={{
                width: "5rem",
                textAlign: mobileView ? "center" : "left",
                paddingLeft: !mobileView ? "1rem" : "0",
              }}
            >
              JR ID
            </TableCell>
            <TableCell
              style={{
                width: "6rem",
                textAlign: mobileView ? "center" : "left",
                paddingLeft: !mobileView ? "1rem" : "0",
              }}
            >
              Invoice Amount
            </TableCell>
            <TableCell
              style={{
                width: "6rem",
                textAlign: mobileView ? "center" : "left",
                paddingLeft: !mobileView ? "1rem" : "0",
              }}
            >
              {user.vendorMode ? "Received Amount" : "Paid Amount"}
            </TableCell>
            {user.vendorMode ? (
              <TableCell
                style={{
                  width: "6rem",
                  textAlign: mobileView ? "center" : "left",
                  paddingLeft: !mobileView ? "1rem" : "0",
                }}
              >
                Bank Account
              </TableCell>
            ) : null}
            <TableCell
              style={{
                width: "6rem",
                textAlign: mobileView ? "center" : "left",
                paddingLeft: !mobileView ? "1rem" : "0",
              }}
            >
              Balance
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>{getTableRows(filteredTransactionData)}</TableBody>
      </Table>
    </TableContainer>
  );
});

export default FinanceTable;
